import React from "react";
import useTranslation from "next-translate/useTranslation";
import { Stack } from "@chakra-ui/react";
import { FormInput } from "src/shared/components/FormInput";
import { IS_HYBRIDGE } from "../../../../../shared/consts";

const NameInput = () => {
  const { t } = useTranslation();
  return (
    <Stack spacing={"40px"}>
      <FormInput
        name="firstName"
        label={IS_HYBRIDGE ? "Doctor first name" : t("smile:pixSignup_firstNameLabel")}
        isRequired={true}
      />
      <FormInput
        name="lastName"
        label={IS_HYBRIDGE ? "Doctor last name" : t("smile:pixSignup_lastNameLabel")}
        isRequired={true}
      />
      <FormInput name="phone" type="tel" label={t("smile:smileSignup_phoneLabel")} isRequired={true} />
    </Stack>
  );
};

export default NameInput;
